export default "__VITE_ASSET__3a5735ad__"